import './App.css';
import Profile from './component/Home/Profile';
import Nav from './component/Nav';

function App() {
  return (
    <div >
      <Nav/>
      <Profile/>
    </div>
  );
}

export default App;
